import React, {useContext, useEffect, useState} from 'react';
import "./styles.scss"
import ReportInput from "../ReportInput";
import Selector from "../Selector";
import {useNavigate, useParams} from "react-router-dom";
import {useGet, usePut} from "../../api/request";
import GlobalError from "../GlobalError";
import Loader from "../Loader";
import {useAlert} from "../AlertNotification";
import { ActionContext } from '../../context/actionContext';

const Modal = ({modalStatus, setModalStatus, onStatusUpdated}) => {
    const { action, setAction } = useContext(ActionContext);
    const navigate = useNavigate();
    const getU = useGet();
    const putU = usePut();
    const alertU = useAlert();

    const [isLoading, setIsLoading] = useState(true);

    const [values, setValues] = useState({
        status: '',
        comment: '',
        phone: '',
        email: '',
        anotherContact: ''
    })

    const [errors, setErrors] = useState({
        status: '',
        comment: '',
        phone: '',
        email: '',
        anotherContact: ''
    })

    const [listOfStatuses, setListOfStatuses] = useState([])

    const handleChangeValues = (event) => {
        let value = event.target.value;
        
        if (event.target.name === 'email' || event.target.name === 'phone') {
            value = value.replace(/\s/g, '');
        }
        
        setValues({
            ...values,
            [event.target.name]: value
        });
        setErrors({
            ...errors,
            [event.target.name]: ''
        });
    };

    const handleChangeStatus = (name) => {
        const selectedStatus = listOfStatuses.find(s => s.name === name);
        setValues({
            ...values,
            status: selectedStatus ? selectedStatus.key : name
        });
        setErrors({
            ...errors,
            status: ''
        });
    };


    const validation = () => {
        let isValid = true;
        let formErrors = {...errors};

        if (values.status === '') {
            formErrors.status = 'Поле должно быть заполненно';
            isValid = false;
        }

        if (values.status === 'contact') {
            const emailTrimmed = values.email?.trim() || '';
            const phoneTrimmed = values.phone?.trim() || '';
            const anotherContactTrimmed = values.anotherContact?.trim() || '';
            
            if (!emailTrimmed && !phoneTrimmed && !anotherContactTrimmed) {
                formErrors.email = 'Необходимо заполнить хотя бы одно поле: почта, телефон или другие контакты';
                formErrors.phone = '';
                formErrors.anotherContact = '';
                isValid = false;
            }
        }

        setErrors(formErrors);
        return isValid
    }


    const onSave = () => {
        if (!validation()) return;

        const data = {
            status: values.status
        }

        if (values.comment?.trim()){
            data.comment = values.comment.trim()
        }
        if (values.phone?.trim()){
            data.phone = values.phone.trim()
        }
        if (values.email?.trim()){
            data.email = values.email.trim()
        }
        if (values.anotherContact?.trim()){
            data.anotherContact = values.anotherContact.trim()
        }

        putU(`applications/${modalStatus.id}`, data)
            .then((response) => {
                if (response.status === "success") {
                    setAction(true)
                    alertU({
                        status: 'success',
                        title: 'Обновление статуса',
                        message: 'Вы успешно обновили статус заявки'
                    });
                    setModalStatus({
                        isActive: false,
                        id: 0,
                    })
                    if (onStatusUpdated) {
                        onStatusUpdated();
                    }
                }
            })
            .catch((e) => {
                alertU({
                    status: 'error',
                    title: 'Обновление статуса',
                    message: e.response?.data?.message
                });
            })
            .finally(() => {
                setIsLoading(false)
            })
    }


    const loadLists = async () => {

        try {
            const [statusesResponse, applicationResponse] = await Promise.all([
                getU("applications/statuses"),
                getU(`applications/${modalStatus.id}`)
            ]);

            if (statusesResponse.status === "success") {
                setListOfStatuses(statusesResponse.data.statuses)
            }

            if (applicationResponse.status === 'success') {
                const data = applicationResponse.data.application;
                setValues({
                    status: data.status,
                    comment: data.comment === 'null' || data.comment === null ? '' : (data.comment || ''),
                    phone: data.phone === 'null' || data.phone === null ? '' : (data.phone || ''),
                    email: data.email === 'null' || data.email === null ? '' : (data.email || ''),
                    anotherContact: data.anotherContact === 'null' || data.anotherContact === null ? '' : (data.anotherContact || '')
                })
            }
        } catch (e) {
            alertU({
                status: 'error',
                title: 'Получение заявок',
                message: 'Произошла ошибка при попытке получить данные'
            });
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (modalStatus.id !== 0) {
            loadLists();
        }
    }, [modalStatus.id])

    const mouseDownTargetRef = React.useRef(null);

    const handleMouseDown = (e) => {
        mouseDownTargetRef.current = e.target;
    };

    const handleBackdropClick = (e) => {
        const modalContent = e.currentTarget.querySelector('.modal-status__content');
        const clickedOnBackdrop = e.target === e.currentTarget;
        const mouseDownWasOnModal = modalContent && modalContent.contains(mouseDownTargetRef.current);
        
        if (clickedOnBackdrop && !mouseDownWasOnModal) {
            setModalStatus({
                id: 0,
                isActive: false
            });
        }
        mouseDownTargetRef.current = null;
    };

    return (
        <div className={modalStatus.isActive ? 'modal-status active' : "modal-status"}
             onMouseDown={handleMouseDown}
             onClick={handleBackdropClick}
        >
            <div className={modalStatus.isActive ? 'modal-status__content active' : "modal-status__content"}
                 onClick={e => e.stopPropagation()}
            >
                <div className="modal-status__content__title">
                    Заявка №{modalStatus.id}
                </div>


                <div className="main__form">
                    <div className="main__form-one-inputs-block">
                        <div className="main__form-input-alone">
                            <Selector
                                title="Статус"
                                name="status"
                                onChange={handleChangeStatus}
                                value={listOfStatuses.find(s => s.key === values.status)?.name || values.status}
                                error={errors.status}
                                placeholder="Выберите статус"
                                listOfCountry={listOfStatuses}
                            />
                        </div>
                    </div>
                    {(values.status === "refuse" || values.status === "contact") &&
                    <div className="main__form-one-inputs-block">
                        <div className="main__form-input-alone">
                            <ReportInput
                                name="comment"
                                title="Комментарий"
                                value={values.comment}
                                onChange={handleChangeValues}
                                placeholder="Введите комментарий"
                                error={errors.comment}
                            />
                        </div>
                    </div>
                    }
                    {values.status === "contact" &&
                    <>
                        <div className="main__form-one-inputs-block">
                            <div className="main__form-input-alone">
                                <ReportInput
                                    name="email"
                                    title="Почта"
                                    value={values.email}
                                    onChange={handleChangeValues}
                                    placeholder="Введите почту"
                                    error={errors.email}
                                />
                            </div>
                        </div>
                        <div className="main__form-one-inputs-block">
                            <div className="main__form-input-alone">
                                <ReportInput
                                    name="phone"
                                    title="Номер телефона"
                                    value={values.phone}
                                    onChange={handleChangeValues}
                                    placeholder="Введите номер телефона"
                                    error={errors.phone}
                                />
                            </div>
                        </div>
                        <div className="main__form-one-inputs-block">
                            <div className="main__form-input-alone">
                                <ReportInput
                                    name="anotherContact"
                                    title="Другие контакты"
                                    value={values.anotherContact}
                                    onChange={handleChangeValues}
                                    placeholder="Введите другой контакт"
                                    error={errors.anotherContact}
                                />
                            </div>
                        </div>
                    </>
                    }


                    <div className="main__form__buttons">
                        <button className="main__form__buttons-save" onClick={onSave}>
                            Сохранить
                        </button>
                        <button className="main__form__buttons-discard"
                                onClick={() => setModalStatus({
                                    id: 0,
                                    isActive: false
                                })}
                        >
                            Выйти
                        </button>
                    </div>
                </div>


            </div>
            {isLoading && (
                <Loader/>
            )}
        </div>
    );
};

export default Modal;
